import { FC, useMemo } from 'react';
import {
  Buttons as RightButtons,
  Page,
  TableWrapper,
} from '../../../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Export from '../../../../components/Export/Export';
import Table from '../../../../components/Table/Table';
import { ConfirmationProps } from './Confirmation.types';
import Button from '../../../../components/Button/Button';
import { Variant } from '../../../../components/Button/Button.types';
import { ColDef } from 'ag-grid-community';

const Confirmation: FC<ConfirmationProps> = ({ saveResponse, setStep }) => {

  const defaultColDef = useMemo<ColDef>(() => {
    return {
      wrapHeaderText: false,
      resizable:true,
      tooltipValueGetter: (params) => params.value,
      filter: true,
      floatingFilter: true,
      tooltipShowDelay: 0
    };
  }, []);

  return (
    <Page>
      <TableWrapper>
        <Table
          height={'100%'}
          rowData={saveResponse}
          noRowsMessage="No new subspecs were created- subspecs with the selected target characteristics already exist."
          columnDefs={[
            { field: 'specNo', headerName: 'SpecNo' },
            { field: 'classNo', headerName: 'Class', flex: 0.5 },
            { field: 'classDesc', headerName: 'Class Description', flex: 1.5 },
            { field: 'baseNo', headerName: 'Base', flex: 0.5 },
            { field: 'baseDesc', headerName: 'Base Description', flex: 1.5 },
            { field: 'sizeNo', headerName: 'Size', flex: 0.5 },
            { field: 'sizeDesc', headerName: 'Size Description', flex: 1.5 },
            { field: 'prodNo', headerName: 'Prod', flex: 0.5 },
            { field: 'prodDesc', headerName: 'Prod Description', flex: 1.5 },
            { field: 'optionNo', headerName: 'Option', flex: 0.5 },
            { field: 'optionDesc', headerName: 'Option Description', flex: 1.5 },
            { field: 'rawProdNo', headerName: 'Raw Product', flex: 0.5 },
            { field: 'rawProdDesc', headerName: 'Raw Product Description', flex: 1.5 },
          ]}
          defaultColDef={defaultColDef}
          showFooter={false}
        />
      </TableWrapper>
      <RightButtons>
        <Export
          testId="exportButton"
          rowData={saveResponse}
          columnHeaders={[
            { field: 'specNo', headerName: 'SpecNo' },
            { field: 'classNo', headerName: 'Class' },
            { field: 'classDesc', headerName: 'Class Description' },
            { field: 'baseNo', headerName: 'Base' },
            { field: 'baseDesc', headerName: 'Base Description' },
            { field: 'sizeNo', headerName: 'Size' },
            { field: 'sizeDesc', headerName: 'Size Description' },
            { field: 'prodNo', headerName: 'Prod' },
            { field: 'prodDesc', headerName: 'Prod Description' },
            { field: 'optionNo', headerName: 'Option' },
            { field: 'optionDesc', headerName: 'Option Description' },
            { field: 'rawProdNo', headerName: 'Raw Product' },
            { field: 'rawProdDesc', headerName: 'Raw Product Description' },
          ]}
        />
        {/* Covered in a future story */}
        {/* <Button label='Change Usage' variant={Variant.Secondary} onClick={handleChangeUsageClick} /> */}
        <Button
          label={
            'Add More' +
            '\nOptions'
          }
          variant={Variant.Secondary}
          onClick={() => setStep(0)}
        />
      </RightButtons>
    </Page>
  );
};

export default Confirmation;
